// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
export const SessionApi = {
    // This endpoint is used to create a session token for a user.
    CreateSession(fn, req) {
        return fn(`/session-api/v1/session`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSession(fn, req) {
        try {
            fm.validateUrlParam(req["sessionId"], "sessionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/session-api/v1/session/${req["sessionId"]}?${fm.renderURLSearchParams(req, ["sessionId"])}`, { method: "GET" });
    },
    SetSessionContext(fn, req) {
        try {
            fm.validateUrlParam(req["sessionId"], "sessionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/session-api/v1/session/${req["sessionId"]}/context`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSession(fn, req) {
        try {
            fm.validateUrlParam(req["sessionId"], "sessionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/session-api/v1/session/${req["sessionId"]}?${fm.renderURLSearchParams(req, ["sessionId"])}`, { method: "DELETE" });
    },
    ListSessions(fn, req) {
        try {
            fm.validateUrlParam(req["userId"], "userId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/session-api/v1/list/${req["userId"]}?${fm.renderURLSearchParams(req, ["userId"])}`, { method: "GET" });
    },
};
